/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCommentDelete = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-comment-delete_svg__st0{fill:currentcolor}'}</style>
    <path className="ico-comment-delete_svg__st0" d="M6 11h8v2H6zm0-4h12v2H6z" />
    <path
      className="ico-comment-delete_svg__st0"
      d="M2 2v20h3.5l3-4H14v-2H7.5l-3 4H4V4h16v6h2V2z"
    />
    <path
      className="ico-comment-delete_svg__st0"
      d="M20.3 12.3 19 13.6l-1.3-1.3-1.4 1.4 1.3 1.3-1.3 1.3 1.4 1.4 1.3-1.3 1.3 1.3 1.4-1.4-1.3-1.3 1.3-1.3z"
    />
  </Icon>
);
export { SvgCommentDelete as CommentDelete };
